module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAABCAYAAADn9T9+AAAAGUlEQVR42mJct3btGQbsYA0Qd0DZBgABBgB6uwQ67sVXJAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/dotted-line.png
// module id = 1096
// module chunks = 2